
export class UidGenerator {
    static NewUid(): string {
        const uidLength = 112;
        return this.RandomString(uidLength).toUpperCase();
    }
    static NewGuid(): string {
        const guidLength = 36;
        return this.RandomString(guidLength);
    }
    private static RandomString(length: number) {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        let text = "";
        while (text.length < length) {
            const addText = s4();
            text += addText;
        }
        if (text.length > length) {
            text = text.substring(0, length);
        }
        return text;
    }
}
